import { IAppState } from '../../common/state';

export function selectNewbuildingBrokerFlightEnabled(state: IAppState) {
  return state.featureToggle.isNewbuildingBrokerFlightEnabled ?? undefined;
}
